import React from 'react'
import { Navigate } from "react-router-dom";

 const PublicRoute = ({
    isAllowed,
    redirectPath = '/',
    children,
  }) => {
    if (isAllowed) {
      return <Navigate to={redirectPath} replace />;
    }
  
    return children;
  };
  export default PublicRoute